module.exports = __webpack_public_path__ + "static/media/webshop.f760de03.png";